module.exports = __webpack_public_path__ + "static/media/settings.f87c74f5.svg";